import React, {useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    Form,
    Popconfirm,
    Table,
    TableButton,
    longDisplayDate,
    notification,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {appAxios as axios, getToken} from "../../request";
import {deleteCouponFxn, fetchCoupon} from "./actions";
import {addCouponUrl} from "./api";

function AddCoupon(props) {
    let tableRef = useRef();
    let dispatch = useDispatch();

    const navigate = useNavigate();

    let events = {
        deleteCoupon: async (id) => {
            let resp = await dispatch(deleteCouponFxn({couponId: id}));
            if (resp && resp.success) {
                tableRef.current.reload();
            }
        },
    };
    const handleSubmit = async (e) => {
        const {form} = props;

        e.preventDefault();
        form.validateFields(async (err, valData) => {
            if (!err) {
                if (valData.discount > 20) {
                    notification.warning({message: "Discount cannot be more than 20%"});
                    return;
                }
                const response = await axios.post(addCouponUrl(), valData, getToken());
                if (response.data.success) {
                    notification.success({
                        message: response.data.message || "Success",
                    });
                    props.form.setFieldsValue({
                        discount: "",
                        mobileNo: "",
                    });
                    tableRef.current.reload();
                } else {
                    notification.error({message: response.data.message});
                }
            } else {
                if (!valData.discount) {
                    notification.warning({message: "Please Enter Discount"});
                    return;
                }
                if (!valData.mobileNo) {
                    notification.warning({message: "Please Enter MobileNo"});
                    return;
                }
            }
        });
    };

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                const data = await fetchCoupon({
                    ...params,
                    regExFilters: ["couponCode", "discount", "mobileNo"],
                });
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const columns = [
        {
            title: "Coupon Code",
            dataIndex: "couponCode",
            searchTextName: "couponCode",

            key: "couponCode",
        },
        {
            title: "Discount in Percentage",
            dataIndex: "discount",
            searchTextName: "discount",

            key: "discount",
        },
        {
            title: "Mobile No",
            dataIndex: "mobileNo",
            searchTextName: "mobileNo",

            key: "mobileNo",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",

            render: (status, record) => {
                const isExpired =
                    record.expiryDate && new Date(record.expiryDate) < new Date();
                const isNotUsed = status !== "used";

                if (isExpired && isNotUsed) {
                    return "Expired";
                } else {
                    return status;
                }
            },
        },
        {
            title: "Expiry Date",
            dataIndex: "expiryDate",
            key: "expiryDate",
            render: (expiryDate) => {
                // You can format the date as needed
                return longDisplayDate(expiryDate);
            },
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (createdAt) => {
                // You can format the date as needed
                return longDisplayDate(createdAt);
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (val, record) => {
                return (
                    <>
                        {" "}
                        <TableButton
                            type={"edit"}
                            onClick={() => {
                                navigate(`/editCoupon?_id=${record._id}`);
                            }}
                        />
                        <Popconfirm
                            title={"Are you sure, you want to delete this Coupon?"}
                            onConfirm={() => {
                                events.deleteCoupon(record._id);
                            }}
                        >
                            <TableButton type={"close"}/>
                        </Popconfirm>
                    </>
                );
            },
        },
    ];
    let inputTypes = {
        fields: [
            {
                key: "discount",
                label: "Discount in Percentage",
                span: "col-md-4",
                type: "number",
                required: true,
            },
            {
                key: "mobileNo",
                label: "Mobile Number",
                span: "col-md-4",
                required: true,
            },
        ],
    };

    return (
        <PageHeader title={"Coupons"}>
            <Form onSubmit={handleSubmit}>
                <div className="form-elements-wrapper">
                    <div className="card-body">
                        <div className={"row"}>
                            {inputTypes.fields.map((item, key) => {
                                return !item.hidden ? (
                                    <div
                                        className={`${item.span ? item.span : "col-md-6"}`}
                                        key={key}
                                    >
                                        <GetEachFormFields {...props.form} item={item}/>
                                    </div>
                                ) : null;
                            })}
                        </div>
                    </div>
                </div>

                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
            </Form>
            <div className="row mt-3">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <Table apiRequest={apiRequest} columns={columns} ref={tableRef}/>
                        </div>
                    </div>
                </div>
            </div>
        </PageHeader>
    );
}

export default Form.create()(AddCoupon);
